<template lang="pug">
  div
    div(class="ie-notification") "We have detected that you are using Internet Explorer. Please consider using other web browsers such as Chrome, Firefox or Safari for a better viewing experience."
</template>

<script>
export default {
  name: 'NotificationInternetExplorer'
}
</script>



// WEBPACK FOOTER //
// src/components/templates/NotificationInternetExplorer.vue